export const deliverabilityPostmasterAppGroupIdDomainReputation =
  "/deliverability/postmaster/:app_group_id/domain_reputation";
